import produce from 'immer'
import React from 'react'
import Button from 'src/components/base/Button'
import Input from 'src/components/base/Input'
import SelectInput from 'src/components/base/SelectInput'
import { Config, Quay } from 'src/types'
import { confirmDeletePopup } from 'src/components/popup/confirmDeletePopup'

import QuayConfigBerthSection from './QuayConfigBerthSection'
import { DEFAULT_OPERATION, QUAY_ROLE, QUAY_TYPE } from './constants'
import QuayConfigMobruSection from './QuayConfigMobruSection'
import QuayConfigJettySection from './QuayConfigJettySection'

import './QuayConfiguration.scss'

export type TPropsQuayConfiguration = {
  config: Quay
  setConfig: React.Dispatch<React.SetStateAction<Config>>
  customFetch: (url: string, options: RequestInit, customResolver?: (r: Response) => any) => Promise<any>
}

function QuayConfiguration({ config, setConfig, customFetch }: TPropsQuayConfiguration) {
  const onDeleteQuay = () => {
    confirmDeletePopup({
      itemName: config.name,
      onConfirm: () => {
        setConfig(
          produce((draft: Config) => {
            draft.quays = draft.quays.filter(quay => quay.name !== config.name)
          })
        )
      },
      alert: true
    })
  }

  return (
    <div className="quay-configuration-container">
      <div className="quay-configuration">
        <div className="topbar">
          <div className="topbar-section">
            <div className="topbar-title">
              <span className="neutral-title">Quay configuration</span>
              <h2>{config.name}</h2>
            </div>
            <div className="topbar-actions">
              <Button variant="danger-primary" onClick={onDeleteQuay}>{`Delete ${config.name}`}</Button>
            </div>
          </div>
        </div>
        <div className="content">
          <form>
            <div className="tq-form">
              <div className="tq-form-group">
                <Input
                  label="Quay name"
                  id="quay-name"
                  value={config.name}
                  onChange={e => {
                    const newName = e.target.value
                    setConfig(
                      produce((draft: Config) => {
                        draft.quays.find(quay => quay.name === config.name).name = newName
                      })
                    )
                  }}
                  required
                />
                <Input
                  label="Bollard start"
                  id="bollard-start"
                  type="number"
                  value={config.minBollard}
                  onChange={e => {
                    const newMinBollard = Number(e.target.value)
                    setConfig(
                      produce((draft: Config) => {
                        draft.quays.find(quay => quay.name === config.name).minBollard = newMinBollard
                      })
                    )
                  }}
                  required
                />
                <Input
                  label="Bollard end"
                  id="bollard-end"
                  type="number"
                  value={config.maxBollard}
                  onChange={e => {
                    const newMaxBollard = Number(e.target.value)
                    setConfig(
                      produce((draft: Config) => {
                        draft.quays.find(quay => quay.name === config.name).maxBollard = newMaxBollard
                      })
                    )
                  }}
                  required
                />
              </div>
              <div className="tq-form-group">
                <SelectInput
                  label="Quay type"
                  id="quay-type"
                  onSelectedOptionChange={option => {
                    setConfig(
                      produce((draft: Config) => {
                        draft.quays.find(quay => quay.name === config.name).quayType = option
                      })
                    )
                  }}
                  selectedOption={config.quayType}
                  options={Object.values(QUAY_TYPE)}
                  required
                />
                <SelectInput
                  label="Quay role"
                  id="quay-role"
                  onSelectedOptionChange={option => {
                    setConfig(
                      produce((draft: Config) => {
                        draft.quays.find(quay => quay.name === config.name).role = option
                      })
                    )
                  }}
                  selectedOption={config.role}
                  options={Object.values(QUAY_ROLE)}
                  required
                />
                <SelectInput
                  label="Default operation"
                  id="default-operation"
                  onSelectedOptionChange={option => {
                    setConfig(
                      produce((draft: Config) => {
                        draft.quays.find(quay => quay.name === config.name).defaultUnloading =
                          option === DEFAULT_OPERATION.unloading
                      })
                    )
                  }}
                  selectedOption={config.defaultUnloading ? DEFAULT_OPERATION.unloading : DEFAULT_OPERATION.loading}
                  options={Object.values(DEFAULT_OPERATION)}
                  required
                />
              </div>
            </div>
          </form>
          <QuayConfigBerthSection config={config} setConfig={setConfig} customFetch={customFetch} />
          <QuayConfigMobruSection config={config} setConfig={setConfig} />
          <QuayConfigJettySection config={config} setConfig={setConfig} />
        </div>
      </div>
    </div>
  )
}

export default QuayConfiguration
